import React  from 'react';
import {css} from "@emotion/css";

const ThemeColorToggle = () => {

    const body = document.body
    let themeColor = ""

    if (localStorage) {
        themeColor = localStorage.getItem("themeColor");
    }

    if (themeColor && themeColor.length > 0) {
        body.classList.add(themeColor);
    } else {
        themeColor = ThemeColor.Purple;
        body.classList.add(themeColor);
    }

    function changeThemeColor(color) {
        switch (themeColor) {
            case ThemeColor.Purple: {
                doChangeThemeColor(ThemeColor.Purple, color)
                break;
            }
            case ThemeColor.Green: {
                doChangeThemeColor(ThemeColor.Green, color)
                break;
            }
            case ThemeColor.Blue: {
                doChangeThemeColor(ThemeColor.Blue, color)
                break;
            }
            case ThemeColor.Red: {
                doChangeThemeColor(ThemeColor.Red, color)
                break;
            }
            case ThemeColor.Orange: {
                doChangeThemeColor(ThemeColor.Orange, color)
                break;
            }
            default: {
                doChangeThemeColor(ThemeColor.Purple, color)
                break;
            }

        }
    }

    function doChangeThemeColor(lastThemeColor, newThemeColor) {
        body.classList.replace(lastThemeColor, newThemeColor);
        localStorage.setItem("themeColor", newThemeColor)
        themeColor = newThemeColor
    }

    return (
        <div className={css`
          display: flex;
          flex-direction: column;
          padding: 16px;
          gap: 16px;
          align-items: center;
        `}>
            <div
                className={css`
                  display: flex;
                  flex-direction: row;
                  gap: 16px;
                  width: 100%;
                `}>

                <div
                    className={`${css`
                      height: 48px;
                      cursor: pointer;
                      flex-grow: 1;
                      background-color: var(--color-purple);
                      border-radius: var(--default-border-radius);`}`}
                    onClick={_ => {
                        changeThemeColor(ThemeColor.Purple)
                    }}
                />

                <div
                    className={`${css`
                      height: 48px;
                      flex-grow: 1;
                      cursor: pointer;
                      background-color: var(--color-blue);
                      border-radius: var(--default-border-radius);`}`}
                    onClick={_ => {
                        changeThemeColor(ThemeColor.Blue)
                    }}
                />

                <div
                    className={`${css`
                      height: 48px;
                      flex-grow: 1;
                      cursor: pointer;
                      background-color: var(--color-orange);
                      border-radius: var(--default-border-radius);`}`}
                    onClick={_ => {
                        changeThemeColor(ThemeColor.Orange)
                    }}
                />

                <div
                    className={`${css`
                      height: 48px;
                      flex-grow: 1;
                      cursor: pointer;
                      background-color: var(--color-red);
                      border-radius: var(--default-border-radius);`}`}
                    onClick={_ => {
                        changeThemeColor(ThemeColor.Red)
                    }}
                />

                <div
                    className={`${css`
                      height: 48px;
                      flex-grow: 1;
                      cursor: pointer;
                      background-color: var(--color-green);
                      border-radius: var(--default-border-radius);`}`}
                    onClick={_ => {
                        changeThemeColor(ThemeColor.Green)
                    }}
                />

            </div>

        </div>
    )
}

export default ThemeColorToggle;


export const ThemeColor = {
    Purple: "Purple",
    Red: "Red",
    Green: "Green",
    Blue: "Blue",
    Orange: "Orange",
}

